import axios from "axios";

const LOCAL_BACKEND_URL = [
  "http:",
  "//",
  "127.0.0.1:8000",
].join("");

export const BACKEND_URL =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname)
    ? LOCAL_BACKEND_URL
    : process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("nv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config.url?.startsWith("/it/vault/")) {
    const vaultToken = sessionStorage.getItem("nv_vault_token");
    if (vaultToken) config.headers["X-Vault-Token"] = vaultToken;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 403 &&
      error.config?.url?.startsWith("/it/vault/") &&
      !error.config.url.startsWith("/it/vault/access") &&
      !error.config.url.startsWith("/it/vault/archive")
    ) {
      sessionStorage.removeItem("nv_vault_token");
      window.dispatchEvent(new Event("nv-vault-locked"));
    }
    return Promise.reject(error);
  }
);

export const CATEGORIES = [
  { slug: "all", name: "All Products" },
  { slug: "sarees", name: "Sarees" },
  { slug: "bedsheets", name: "Bedsheets" },
  { slug: "daily-essentials", name: "Daily Essentials" },
];

export const formatINR = (v) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
